import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyPortfolioPagesRoute: InvariantJiraRoute = {
	name: 'legacy-portfolio-pages',
	path: '/secure/PortfolioPlan(\\w+).jspa',
};
